module.exports = __webpack_public_path__ + "static/assets/c43067ac15b97f2ee789fb30db63565d.svg";